import { SINGLE_NUMERIC } from './_argShapes';
import { STUB_NOT_IMPLEMENTED } from './_stubs';
import type { EffectEntry } from './types';

export const delay: EffectEntry = {
  kind: 'delay',
  category: 'effect',
  family: 'delay',
  doc: 'delay wet amount (0 off, 0.3 slap, 0.6 dub)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('delay', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('delay', 'fromAst'),
};

export const delaytime: EffectEntry = {
  kind: 'delaytime',
  category: 'effect',
  family: 'delay',
  doc: 'delay time in seconds (0.1875 = dotted 8th at 125 BPM)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('delaytime', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('delaytime', 'fromAst'),
};

export const delayfb: EffectEntry = {
  kind: 'delayfb',
  category: 'effect',
  family: 'delay',
  doc: 'delay feedback (0 single repeat, 0.8 decaying, 0.95 dub)',
  args: SINGLE_NUMERIC,
  toCode: () => STUB_NOT_IMPLEMENTED('delayfb', 'toCode'),
  fromAst: () => STUB_NOT_IMPLEMENTED('delayfb', 'fromAst'),
};
